import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Russellville, AR?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Russellville can take 2–6 months, especially during peak travel seasons. For Arkansas Nuclear One professionals with international assignments, ATU students with study-abroad deadlines, and mission team members with fixed departure dates, that timeline is simply not viable.",
  },
  {
    q: "Can Arkansas Nuclear One professionals get a passport quickly for international assignments?",
    a: "Absolutely. Nuclear industry professionals are one of our most common client types in the Russellville area. International assignments to IAEA meetings, peer plant inspections in France and Japan, and industry conferences often arrive with 2–4 week notice. We provide expedited passport renewals and new applications with processing as fast as 2–9 business days for most eligible applicants — well within a typical nuclear industry assignment timeline.",
  },
  {
    q: "Can ATU students get a passport fast for study abroad?",
    a: "Yes. Arkansas Tech University study-abroad programs have application deadlines that often fall in October and February, but many students do not think about their passport until after acceptance. First-time applicants — which describes most college students who have never traveled internationally — require an in-person acceptance clerk visit. We guide ATU students through the Pope County acceptance clerk locations, required forms, and exact timeline so they do not miss their program orientation.",
  },
  {
    q: "Can church mission teams in Russellville get passports quickly?",
    a: "Yes — and this is one of our most common Russellville requests. Mission teams often finalize participant lists 2–4 weeks before departure, and first-time travelers on those teams have never needed a passport before. We help mission team leaders manage the process for multiple team members simultaneously, providing checklists, acceptance clerk guidance, and expedited processing options that fit mission trip timelines.",
  },
  {
    q: "How far is Russellville from the nearest passport agency?",
    a: "The nearest regional passport agency to Russellville is in Little Rock — approximately 100 miles east via I-40. Getting an appointment there requires documented urgent travel and the agency's appointment calendar. Fast Passport Center eliminates that trip entirely. Start your order online, ship your documents overnight from Russellville, and we handle the submission through our reserved courier access.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Russellville travelers start online and ship their documents via overnight courier. There is no Fast Passport Center office in Russellville, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from any FedEx or UPS location in the River Valley area.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function RussellvilleFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Russellville and Arkansas River Valley travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}